import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { CORE_ACTIONS, State } from './index';

export interface IFacade {
  /**
   * Dispatches an action.
   *
   * @deprecated keep dispatch calls encapsulated inside the facade.
   */
  dispatch(action: Action): void;

  // Selects from state using a factory method that takes arguments.
  selectWithProps(func: Function, ...props: any[]): Observable<any>;
}

@Injectable()
export class CoreFacade implements IFacade {
  constructor(private store: Store<State>) { }

  /**
   * @deprecated keep dispatch calls encapsulated inside the facade.
   */
  dispatch(action: Action): void {
    this.store.dispatch(action);
  }

  resetState() {
    this.store.dispatch({ type: CORE_ACTIONS.resetState });
  }

  selectWithProps(func: Function, ...props: any[]): Observable<any> {
    return this.store.select(func(...props));
  }
}
